// extracted by mini-css-extract-plugin
export default {"root":"NotFound_root__VgCkL","label":"NotFound_label__AelT9","description":"NotFound_description__hi4RQ","title":"NotFound_title__WU4Fl"};